<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
		  <el-form-item>
		  	  <el-button type="danger" icon="el-icon-plus" size="small" round @click="addsettings">新增</el-button>
			  <el-button type="primary" icon="el-icon-refresh" size="small" circle @click="getlists"></el-button>
		  </el-form-item>
		  <el-form-item>
		  	  <div class="doudian-setting-notice">警告：非技术人员请勿对下面店铺设置信息进行改动，否则可能导致抖音店铺数据对接瘫痪</div>
		  </el-form-item>
	  </el-form>

	  <div class="backborder2" style="margin-top:10px">
	  	  <div class="doudian-setting-main-infos" v-loading="query.loading">
			  <div class="doudian-setting-main-infos-lists" v-for="(item,index) in settinglists" :key="index">
			  	  <div class="doudian-setting-main-infos-lists-logo-and-names">
					  <div style="width:70%;height:40px;display:flex;align-items:center">
					  <img src="../../assets/doudian_logo.png" />
					  <div class="doudian-setting-main-infos-lists-logo-and-name">{{item.dshopname}}</div>
					  </div>
					  <div style="width:30%;text-align:right;height:40px;display:flex;align-items:center;justify-content:right">
			  	  	  <el-button type="warning" icon="el-icon-setting" circle size="mini" @click="getsettinginfos(item)"></el-button>
					  <el-button type="danger" icon="el-icon-delete" circle size="mini" @click="delsettings(item.id)"></el-button>
					  </div>
				  </div>
				  <div class="doudian-setting-main-infos-lists-singgle">店铺ID：{{item.dshopid}}</div>
				  <div class="doudian-setting-main-infos-lists-singgle">店铺名称：{{item.dshopname}}</div>
				  <div class="doudian-setting-main-infos-lists-singgle">appkey：{{item.appkey}}</div>
				  <div class="doudian-setting-main-infos-lists-singgle">appsecret：{{item.appsecret}}</div>
			  </div>
		  </div>
	  </div>

	  <!-- 新增、编辑设置 -->
	  <el-dialog title="新增 / 编辑店铺配置信息" :visible.sync="settingDialog" width="25%" top="10vh" class="doudian-setting-add-or-edit-dialog">
		  <div class="doudian-setting-add-or-edit"><img src="../../assets/doudian_logo.png" /></div>
		  <div class="doudian-setting-add-or-edit-content">
		  	  <el-form :inline="true" size="small">
				  <el-form-item label-width="120" label="店铺ID">
				  	  <el-input type="text" v-model="addquery.dshopid" size="small"/>
				  </el-form-item>
				  <el-form-item label-width="120" label="店铺名称">
				  	  <el-input type="text" v-model="addquery.dshopname" size="small"/>
				  </el-form-item>
				  <el-form-item label-width="120" label="appkey">
				  	  <el-input type="text" v-model="addquery.appkey" size="small"/>
				  </el-form-item>
				  <el-form-item label-width="120" label="appsecret">
				  	  <el-input type="text" v-model="addquery.appsecret" size="small"/>
				  </el-form-item>
			  </el-form>
		  </div>
		  <div slot="footer" class="dialog-footer">
			<el-button type="primary" size="small" @click="savesettings">确定</el-button>
			<el-button size="small" @click="settingDialog = false">取 消</el-button>
		  </div>
	  </el-dialog>
    
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Dshop/index",
      transitionshow:true,
      actionauth:[],
	  settingDialog:false,

	  query: {
		  act:'getsettinglists',
		  token:this.$cookies.get('token'),
		  loading:false,
	  },
	  settinglists:[],
	  
	  addquery: {
		  act:'savesettings',
		  token:this.$cookies.get('token'),
		  id:'',
		  dshopid:'',
		  dshopname:'',
		  appkey:'',
		  appsecret:'',
	  },
	  
      
    }
  },
  
  
  mounted(){
    //this.getactionauth(); //获取权限设置
	this.getlists();
  },
  
  
  methods:{

	  //删除店铺配置
	  delsettings(id) {
		  this.$confirm('您是否要删除该店铺配置信息，是否继续?', '提示', { type: 'warning' }).then(() => {
              var resource = this.$resource(this.url);
			  resource.save({act:'delsetting',token:this.$cookies.get('token'),id:id}).then((res) => {
				  if(res.data.Result>0){
					  if(res.data.Result=='70001') this.$router.push('/login')
					  this.$message.error(res.data.Message);
				  }else{
					  this.getlists();
				  }
			  }).catch((res) => {
					
			  });
          }).catch(() => {
              
          });

	  },


	  //获取配置信息
	  getsettinginfos(item) {
		  this.addquery.id=item.id;
		  this.addquery.dshopid=item.dshopid;
		  this.addquery.dshopname=item.dshopname;
		  this.addquery.appkey=item.appkey;
		  this.addquery.appsecret=item.appsecret;
		  this.addquery.act='editsettings';

		  this.settingDialog=true;
	  },

	  //保存设置信息
	  savesettings() {
		    var resource = this.$resource(this.url);
			resource.save(this.addquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getlists();
					this.settingDialog=false;
				}
			}).catch((res) => {
				
			});
	  },


	  //新增抖店设置
	  addsettings() {
		  this.settingDialog=true;
		  this.addquery.act='savesettings';
		  this.resetsetting();
	  },

	  //重置数据
	  resetsetting() {
		  this.addquery.id='';
		  this.addquery.dshopid='';
		  this.addquery.dshopname='';
		  this.addquery.appkey='';
		  this.addquery.appsecret='';
	  },
    
      //获取设置信息
	  getlists() {
		  this.query.loading=true;
		  var resource = this.$resource(this.url);
		  resource.save(this.query).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
				  this.query.loading=false;
			  }else{
				  this.settinglists = JSON.parse(Base64.decode(res.data.Data));
				  this.query.loading=false;
			  }
		  }).catch((res) => {
			  this.query.loading=false;
		  });
	  },
    
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.doudian-setting-notice {display:inline-block;font-size:12px;color:red;}
.doudian-setting-main-infos {display:inline-block;width:100%;}
.doudian-setting-main-infos-lists {display:inline-block;overflow:hidden;position:relative;width:calc(24% - 20px - 2px);padding:10px;height:220px;background:#d4e1f7;border:1px solid #d4e1f7;border-radius:6px;margin:10px 10px 0 0;transition:.5s all;}
.doudian-setting-main-infos-lists:hover {box-shadow:5px 5px 10px #ddd}

.doudian-setting-main-infos-lists-logo-and-names {display:inline-block;width:100%;display:flex;align-items:center;margin-bottom:20px;}
.doudian-setting-main-infos-lists-logo-and-names img {width:40px;height:40px;}
.doudian-setting-main-infos-lists-logo-and-name {font-size:16px;line-height:16px;font-weight:550;margin-left:4%;text-shadow:0 2px 4px rgb(0 0 0 / 20%);}
.doudian-setting-main-infos-lists-singgle {display:inline-block;padding:10px 5px;width:calc(100% - 10px);font-size:12px;line-height:12px;text-shadow:0 2px 4px rgb(0 0 0 / 20%);overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.doudian-setting-add-or-edit {display:flex;width:100%;justify-content:center;align-items:center;margin-bottom:20px;}
.doudian-setting-add-or-edit img {width:50px;height:50px;border-radius:50%;transition:.5s all;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:going;-webkit-animation-duration:1000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
@-webkit-keyframes going {
	0% {
	    box-shadow:0 0 0 #f56c6c;
    }
    100% {
    	box-shadow:0 0 20px #f56c6c;
    }
}


.doudian-setting-add-or-edit-content {padding:10px 20px;width:calc(100% - 40px - 2px);min-height:50px;border-radius:6px;border:1px solid #d4e1f7;background:#d4e1f7;}
.doudian-setting-add-or-edit-dialog .el-dialog {background:#d4e1f7}
</style>


// WEBPACK FOOTER //
// src/components/doudian/DoudianSettings.vue